import {
  drawerWidth,
  transition,
  container
} from "assets/jss/material-dashboard-react.jsx";

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    top: "0",
    height: "100vh"
  },
  mainPanel: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch"
  },
  content: {
    marginTop: "70px",
    //padding: "30px 15px",
    minHeight: "calc(100vh - 123px)",
    [theme.breakpoints.down("md")]: {
      padding: 0
    }
  },
  container,
  [theme.breakpoints.down("sm")]: {
    container: {
    padding: 0,
    paddingRight: 0,
    paddingLeft: 0,
  }},
  map: {
    marginTop: "70px"
  }
});

export default appStyle;
